const getEnvironment = () => {
  if (typeof window === "undefined") return;

  return {
    isDev:
      window.location.href.includes("dev") ||
      process.env.NODE_ENV === "development",
    isLocal: window.location.href.includes("localhost"),
  };
};

export default getEnvironment;
